import ProjectCardWrapper from '../../components/projects/ProjectCardWrapper'

// import useFetc from '../hooks/useFetch'

import { dataArr } from '../../data/data.js'

const Work = () => {
  const projects = dataArr

  // const {
  //   data: dataArr,

  //   // error,
  // } = useFetch(
  //   'https://portfolio-api-03f0251d4996.herokuapp.com/api/v.1/projects'
  // )

  return (
    <div className="page-section broad">
      <h1>Projects</h1>

      {projects && <ProjectCardWrapper projectsArr={projects.projects} />}
    </div>
  )
}

export default Work
